import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {ButtonBase} from "@/shared/ui/buttons";
import {getStaticPathIcon} from "@/shared/utils/get-static-path-icon";

import "./styles/view-toggle.scss";

export type ViewMode = "list" | "map";

interface ViewToggleProps {
    currentView: ViewMode;
    onViewChange: (view: ViewMode) => void;
}

export function ViewToggle({currentView, onViewChange}: ViewToggleProps): JSX.Element {
    const toggleView = (): void => {
        onViewChange(currentView === "list" ? "map" : "list");
    };
    const nextView = currentView === "list" ? "map" : "list";
    const iconSrc = nextView === "map" ? getStaticPathIcon("map2") : getStaticPathIcon("list2");

    return (
        <ButtonBase variant="secondary" onClick={toggleView} className="view-toggle">
            <SmartImage src={iconSrc} alt="" width={20} height={20} />
        </ButtonBase>
    );
}
